import { render, staticRenderFns } from "./InputController.vue?vue&type=template&id=614165b0&scoped=true&"
import script from "./InputController.vue?vue&type=script&lang=js&"
export * from "./InputController.vue?vue&type=script&lang=js&"
import style0 from "./InputController.vue?vue&type=style&index=0&id=614165b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614165b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
